"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var classNames = require("classnames");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var types_1 = require("types");
var participantsActions = require("@caddigital/sok-reducers/lib/actions/bid/participants");
var bidListActions = require("@caddigital/sok-reducers/lib/actions/bid/list");
require("./copyParticipant.scss");
var mapStateToProps = function (state) {
    return {
        copy: state.bid.participants.copy,
        userGroups: state.bid.userGroups,
        bidList: state.bid.list
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchParticipants: function (bid) {
        return dispatch(participantsActions.fetchRequest(bid));
    },
    toggleModal: function () { return dispatch(participantsActions.toggleCopyParticipant()); },
    selectBid: function (bid) { return dispatch(participantsActions.selectBid(bid)); },
    fetchBids: function (briefcase) {
        return dispatch(bidListActions.fetchRequest(briefcase));
    },
    copyParticipants: function (selected, targetBid, targetGroup) {
        return dispatch(participantsActions.copyParticipants(selected, targetBid, targetGroup));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.bidList.status === 'STANDBY') {
            this.props.fetchBids(this.props.currentBriefcase);
        }
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { className: 'bid-copy-participants-modal', isOpen: props.copy.isOpen },
    React.createElement(sok_ui_1.RequestStatusBox, { status: props.copy.status, statusList: ['STANDBY', 'COPYING', 'SUCCESS', 'FAILED'] },
        (0, translation_1.getLocalization)('sokobid/participants/modal/copying'),
        (0, translation_1.getLocalization)('sokobid/participants/modal/success'),
        (0, translation_1.getLocalization)('sokobid/participants/modal/failed')),
    React.createElement(sok_ui_1.Header, { onClose: function () { return props.copy.status !== 'COPYING' && props.toggleModal(); } }, (0, translation_1.getLocalization)('sokobid/participants/modal/header')),
    React.createElement(sok_ui_1.Container, null,
        React.createElement("h4", null, (0, translation_1.getLocalization)('sokobid/participants/modal/selectBid')),
        React.createElement("p", null, (0, translation_1.getLocalization)('sokobid/participants/modal/message')),
        React.createElement("label", { htmlFor: 'grouptype' },
            (0, translation_1.getLocalization)('sokobid/participants/modal/selectedBriefcase'),
            ":",
            ' ',
            React.createElement("span", null, props.currentBriefcase.name)),
        React.createElement(sok_ui_1.Dropdown2, null,
            React.createElement(sok_ui_1.TextInput, { className: classNames('select', !props.copy.selected && 'placeholder'), editable: false, value: props.copy.selected
                    ? props.copy.selected.name
                    : (0, translation_1.getLocalization)('sokobid/participants/modal/selectBidPlaceholder'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-caret-down' }) }),
            React.createElement(sok_ui_1.Dropdown2Menu, { className: 'sokobid-copy-participants-menu' }, props.bidList.list
                .filter(function (x) { return x.id !== props.currentBid.id; })
                .map(function (x, i) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "bid-".concat(i), onClick: function () { return props.selectBid(x); } }, x.name)); })))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { color: 'blue', onClick: function () {
                var target = props.userGroups.list.find(function (x) { return x.type === 'ParticipantUserGroup'; });
                props.copy.selected &&
                    target &&
                    props.copyParticipants(props.copy.selected, props.currentBid, target);
            }, text: (0, translation_1.getLocalization)('sokobid/participants/modal/copy'), disabled: !props.copy.selected ||
                props.copy.status === 'COPYING' ||
                props.userGroups.status !== 'FETCHED' }),
        React.createElement(sok_ui_1.Button, { color: 'dark-gray', disabled: props.copy.status === 'COPYING', onClick: function () { return props.toggleModal(); }, text: (0, translation_1.getLocalization)('sokobid/participants/modal/cancel') })))); });
